import { forwardRef } from 'react';
import { styled } from 'goober';
export var ModelContainer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'grid',
        gridTemplateColumns: '100%',
        gridTemplateRows: 'max-content 1fr',
        height: 'calc(100vh - 44px)',
    });
});
export var ModelPanel = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        borderBottom: '1px solid #f1f4f8',
    });
});
export var ModelNoneSelected = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        height: '30vh',
        fontSize: '1.5em',
        opacity: 0.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    });
});
export var ModelTitleBar = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        justifyContent: 'space-between',
        padding: '0 16px',
        borderBottom: "1px solid ".concat(theme.colors.neutral.w300),
        position: 'relative',
        bottom: '-1px', // fake border collapse with finance-toolbar
    });
});
export var ModelTitleBarTags = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        height: '44px',
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        width: '100%',
    });
});
export var ModelContent = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        overflow: 'hidden',
        height: 'fit-content',
        input: {
            fontFamily: '"Inter" !important',
            fontSize: '12px !important',
        },
    });
});
export var ModelToolbar = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        justifyContent: 'flex-start',
        width: '100%',
        height: '100%',
        flexWrap: 'wrap',
        fontSize: '12px',
        borderBottom: "1px solid ".concat(theme.borderColor),
        '>div': {
            height: '40px',
            borderTop: "1px solid ".concat(theme.borderColor),
            display: 'flex',
            flexGrow: 0,
        },
    });
});
export var ModelToolbarButton = styled('button', forwardRef)(function (_a) {
    var theme = _a.theme, $open = _a.$open, $isOnlyIcon = _a.$isOnlyIcon;
    return ({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        outline: 'none',
        border: 'none',
        backgroundColor: $open ? theme.colors.neutral.w100 : 'white',
        fontSize: '12px',
        borderRight: "1px solid ".concat(theme.borderColor),
        padding: '0 16px',
        svg: {
            marginLeft: $isOnlyIcon ? '0px' : '8px',
            fontSize: $isOnlyIcon ? '1.2em' : '0.7em',
            opacity: $isOnlyIcon ? 1 : 0.5,
        },
        '&:hover': {
            backgroundColor: theme.colors.neutral.w100,
            cursor: 'pointer',
        },
        '&[disabled]': {
            opacity: 0.5,
            color: theme.colors.ui.dark,
            cursor: 'not-allowed',
        },
        '&[disabled]:hover': {
            backgroundColor: 'white',
        },
        '&:first-child': {
            borderLeft: "1px solid ".concat(theme.borderColor),
        },
    });
});
export var ModelToolbarButtonsWrap = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        padding: '0 16px',
        borderRight: "1px solid ".concat(theme.borderColor),
    });
});
